"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreaggregatedMetricPropertyNames = void 0;
// Names expected in Breeze side for dimensions
exports.PreaggregatedMetricPropertyNames = {
    cloudRoleInstance: "cloud/roleInstance",
    cloudRoleName: "cloud/roleName",
    operationSynthetic: "operation/synthetic",
    requestSuccess: "Request.Success",
    requestResultCode: "request/resultCode",
    dependencyType: "Dependency.Type",
    dependencyTarget: "dependency/target",
    dependencySuccess: "Dependency.Success",
    dependencyResultCode: "dependency/resultCode",
    traceSeverityLevel: "trace/severityLevel"
};
//# sourceMappingURL=AggregatedMetricDimensions.js.map